"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Special column key for the selection column. Must be defined in this file
// (rather than in SelectionColumn.tsx) to avoid circular imports
exports.SelectionColumnKey = 'selection';
exports.UnsortableColumnKey = '';
//# sourceMappingURL=TypedDataGridInterfaces.js.map